import { PropsWithChildren } from "react";
import { useAuthGuardContext } from "./withAuthGuard";
import { useIsUserDeletedFromOrg } from "~/hooks/useIsUserDeletedFromOrg";
import { ParentComponent } from "~/utils/type-helpers";
import { Navigate } from "@tanstack/react-router";

/**
 * A HOC which ensures that the wrapped component is only rendered
 * if the user is still active in the organization.
 */
export function withOrgMemberGuard<P extends PropsWithChildren<unknown>>(Component: ParentComponent<P>) {
  return function GuardedRoute(props: P) {
    const { ownerOrganizationId, currentUserId } = useAuthGuardContext();

    const [isDeletedFromOrg] = useIsUserDeletedFromOrg({
      userId: currentUserId,
      organizationId: ownerOrganizationId,
    });

    if (isDeletedFromOrg) {
      return <Navigate to="/deactivated" replace />;
    } else {
      return <Component {...props} />;
    }
  };
}
